// Translation: Utility > Feedback (Turkish)
export default Object.freeze({
	hint: 'Geri bildirim bırak!'
})
